<template>
  <div class="drawer" :enable="false">
    <div class="user-avatar"></div>
    <div class="drawer-controls" style="display:flex; align-items:center; gap:8px; padding: var(--space-3); border-bottom: 1px solid var(--grid-lines);">
      <ThemeToggle />
    </div>
    <div class="accordion menu" id="accordionPanelsStayOpenExample">
      <div class="accordion-item" v-if="isUpdateAvailable">

      </div>
      <div class="accordion-item">
        <router-link
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="main franchise stats"
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'dashboard' }"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-chart-simple" />
          Main Dashboard
        </router-link>
      </div>

      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'StockDashboard' }"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-cubes" />
          Stock Reports
        </router-link>
      </div>
      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'SalesDashboard' }"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-cart-arrow-down" />
          Sales Reports
        </router-link>
        <!-- #26214 discoverability: Table Audit Log nested under Sales Reports (manager path from sales investigation) -->
        <router-link
          @click.native="back"
          class="route-btn route-btn--sub w-100 bg-transparent"
          :to="{ name: 'tableAudit' }"
          title="Table Audit Log — kitchen and table operation audit trail"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-clipboard-list" />
          Table Audit Log
        </router-link>
        <!-- Sales Dump Export: per-store Excel pull from AnalyticsDocuments; sub-item under Sales Reports to match IA -->
        <div class="route-btn route-btn--sub sales-dump-export">
          <button
            type="button"
            class="sales-dump-toggle w-100 bg-transparent"
            :aria-expanded="showSalesDumpInputs"
            title="Pull a sales dump (Excel) for the selected store"
            @click="toggleSalesDumpInputs"
          >
            <font-awesome-icon class="icon" icon="fa-solid fa-file-export" />
            <span class="sales-dump-label">Sales Dump Export</span>
            <font-awesome-icon
              class="sales-dump-chevron"
              :class="{ 'rotated': showSalesDumpInputs }"
              icon="fa-solid fa-chevron-down"
            />
          </button>
          <div v-if="showSalesDumpInputs" class="sales-dump-panel">
            <div class="sales-dump-field">
              <label for="salesDumpFrom">From</label>
              <input
                id="salesDumpFrom"
                v-model="selectedStartDate"
                type="date"
                class="sales-dump-date-input"
              />
            </div>
            <div class="sales-dump-field">
              <label for="salesDumpTo">To</label>
              <input
                id="salesDumpTo"
                v-model="selectedEndDate"
                type="date"
                class="sales-dump-date-input"
              />
            </div>
            <button
              v-if="salesDumpReady"
              type="button"
              class="sales-dump-generate"
              @click="generateSalesDump"
            >
              Generate Sales Dump
            </button>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'CashUpDashboard' }"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-cash-register" />
          CashUp Report
        </router-link>
      </div>

      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="financeRoute"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-sack-dollar" />
          Finance Reports
        </router-link>
      </div>

      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'vatReports' }"
          title="VAT Reports"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-file-invoice-dollar" />
          VAT Reports
        </router-link>
      </div>

      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'accountsReports' }"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-user" />
          Accounts Reports
        </router-link>
      </div>
      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'SupervisorDashboard' }"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-mask" />
          Supervisor Report
        </router-link>
        <!-- #26214 discoverability: Table Audit Log nested under Supervisor Report (audit/monitoring IA) -->
        <router-link
          @click.native="back"
          class="route-btn route-btn--sub w-100 bg-transparent"
          :to="{ name: 'tableAudit' }"
          title="Table Audit Log — kitchen and table operation audit trail"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-clipboard-list" />
          Table Audit Log
        </router-link>
      </div>
      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'WarningsReports' }"
          title="Warnings Reports"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-bell" />
          Warnings Reports
        </router-link>
      </div>

      <div class="accordion-item">
        <router-link
          @click.native="back"
          class="route-btn w-100 bg-transparent"
          :to="{ name: 'help' }"
          title="User Manual"
        >
          <font-awesome-icon class="icon" icon="fa-solid fa-book" />
          User Manual
        </router-link>
      </div>

      <div class="accordion-item">
        <a class="route-btn w-100 bg-transparent" @click="logout">
          <font-awesome-icon class="icon" icon="lock" />
          Logout
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ThemeToggle from "@/components/layout/ThemeToggle.vue";
export default {
  name: "NavigationDrawer",
  components: { ThemeToggle },
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  mounted() {
  },
  data() {
    return {
      showSalesDumpInputs: false,
      selectedStartDate: '',
      selectedEndDate: '',
    };
  },
  computed: {
    isUpdateAvailable() {
      return this.$store.getters.getUpdateAvailability;
    },
    selected_store() {
      return this.$store.state.selected_store;
    },
    financeRoute() {
      const store = this.selected_store;
      // If store is null or store name is 'All', go to finance-dashboard, otherwise go to finance
      if (!store || !store.StoreDB || store.StoreName === 'All') {
        return { name: 'FinanceDashboard' };
      } else {
        return { name: 'finance' };
      }
    },
    salesDumpReady() {
      return Boolean(this.selectedStartDate) && Boolean(this.selectedEndDate);
    },
  },
  methods: {
    back() {
      if (this.close) {
        this.close();
      } else {
        console.log("Close not defined");
      }
    },
    updateApp() {
      this.$store.commit(`setUpdateAvailability`, false);
      return window.location.reload(true);
    },

    logout() {
      return Swal.fire({
        icon: `warning`,
        title: `Are you sure?`,
        text: `You will logged out of the application`,
        showCancelButton: true,
        showCloseButton: true,
        reverseButtons: true,
      }).then((res) => {
        if (res.isConfirmed) {
          localStorage.clear();
          return this.$router.push({ name: `Login` });
        }
      });
    },

    toggleSalesDumpInputs() {
      this.showSalesDumpInputs = !this.showSalesDumpInputs;
    },

    generateSalesDump() {
      try {
        const store = this.selected_store;
        if (!store || !store.StoreDB) {
          Swal.fire({
            icon: `warning`,
            title: `Select a store`,
            text: `Choose a specific store before generating a sales dump. The export is generated per store.`,
            showCloseButton: true,
          });
          return;
        }
        if (!this.salesDumpReady) {
          return;
        }
        const base = (window.docsApi || '').replace(/\/$/, '');
        if (!base) {
          Swal.fire({
            icon: `error`,
            title: `Export unavailable`,
            text: `The sales dump service is not configured. Please contact your administrator.`,
            showCloseButton: true,
          });
          return;
        }
        const storeDB = encodeURIComponent(store.StoreDB);
        const url = `${base}/sales/export/excel/${storeDB}/salesdump?from=${this.selectedStartDate}&to=${this.selectedEndDate}`;
        window.open(url, '_blank');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to open sales dump', e);
        Swal.fire({
          icon: `error`,
          title: `Export failed`,
          text: `We couldn't open the sales dump. Please try again.`,
          showCloseButton: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  color: var(--text-secondary);
}

a {
  &:hover,
  &.a-exact-active {
    background: var(--card-bg);
    color: var(--accent-primary);
    font-weight: 700;

    .icon {
      color: var(--accent-primary);
    }
  }
}

.disabled {
  pointer-events: none;
  cursor: move !important;
}

.drawer {
  width: 100%;
  background: var(--card-bg);
  height: 100%;
  overflow-y: auto;
  position: relative;

  .user-avatar {
    position: relative;
    display: flex;
    align-items: center;
    gap: var(--space-4);
    width: 100%;
    color: var(--text-inverse);
    min-height: 160px;
    padding: var(--space-4);
    background-image: var(--nav-bg-image);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .user-avatar::after {
    content: "";
    position: absolute;
    inset: 0;
    background: var(--drawer-overlay);
  }
  .user-avatar > * { position: relative; z-index: 1; }

  .user-avatar .avatar {
    background: var(--card-bg);
    min-width: 64px;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    box-shadow: var(--shadow);
  }

  .user-avatar .avatar-details {
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
  }

  .user-avatar .avatar-details h5,
  .user-avatar .avatar-details p { margin: 0; }
  .user-avatar .avatar-details h5 { font-weight: var(--fw-heading); color: var(--text-inverse); }
  .user-avatar .avatar-details p {
    font-size: 15px;
    color: var(--text-secondary);
    font-weight: 400;
  }
  .user-avatar .avatar-details p.fw-bolder {
    color: var(--accent-primary);
    font-weight: 600;
  }
}

.menu {
  text-align: center;
  background: var(--card-bg);
  border: var(--card-border);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow);

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}

.icon {
  margin-right: 10px;
}

.route-btn {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  padding-left: 10px;
  text-decoration: none;
  color: var(--text-primary);
}

/* #26214 — subordinate drawer entries (e.g. Table Audit Log under Sales / Supervisor) */
.route-btn--sub {
  height: 42px;
  padding-left: 36px;
  font-weight: 500;
  font-size: 0.92em;
  color: var(--text-secondary);

  .icon {
    font-size: 0.9em;
  }
}

/* Sales Dump Export — expandable sub-item with date-range picker */
.sales-dump-export.route-btn--sub {
  height: auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.sales-dump-toggle {
  height: 42px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 0 12px 0 36px;
  border: 0;
  text-align: left;
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.92em;
  cursor: pointer;
  transition: var(--transition);

  &:hover,
  &:focus-visible {
    background: var(--card-bg);
    color: var(--accent-primary);
    outline: none;

    .icon,
    .sales-dump-chevron {
      color: var(--accent-primary);
    }
  }

  .icon {
    margin-right: 0;
  }

  .sales-dump-label {
    flex: 0 1 auto;
  }

  .sales-dump-chevron {
    margin-left: auto;
    font-size: 11px;
    color: var(--text-secondary);
    transition: transform 0.2s ease;

    &.rotated {
      transform: rotate(180deg);
    }
  }
}

.sales-dump-panel {
  padding: 10px 12px 12px 36px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: rgba(51, 156, 255, 0.04);
  border-top: 1px solid var(--grid-lines);
}

.sales-dump-field {
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 12px;
    color: var(--text-secondary);
    font-weight: 500;
  }
}

.sales-dump-date-input {
  width: 100%;
  min-height: 40px;
  padding: 8px 10px;
  border: 1px solid var(--grid-lines);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font-size: 14px;
  transition: var(--transition);

  &:focus {
    outline: none;
    border-color: var(--accent-primary);
    box-shadow: 0 0 0 3px rgba(51, 156, 255, 0.15);
  }
}

.sales-dump-generate {
  width: 100%;
  min-height: 40px;
  margin-top: 4px;
  padding: 8px 12px;
  border: 0;
  border-radius: var(--radius-button);
  background: var(--accent-primary);
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);

  &:hover,
  &:focus-visible {
    background: var(--accent-primary-hover);
    outline: none;
  }
}

#footer {
  bottom: 0;
  position: fixed;
  width: 100%;
}

.not-footer {
  margin-bottom: 100px;
}
</style>


<!-- styles appended by Junie: make Update button match ThemeToggle -->
<style lang="scss" scoped>
.update-btn.lt-theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 1px solid var(--grid-lines);
  background: var(--card-bg);
  color: var(--text-primary);
  border-radius: var(--radius-button);
  transition: var(--transition);
}
.update-btn.lt-theme-toggle:hover { box-shadow: 0 0 0 3px rgba(51,156,255,0.28); }
.update-btn .lt-theme-toggle__icon { font-size: 14px; }
.update-btn .lt-theme-toggle__label { font-size: 12px; font-weight: var(--fw-button); }
</style>
